import React from "react";

import { useParams } from "react-router-dom";

import OfferIcon from "@components/icons/Offer";
import { Checkbox } from "@components/inputs/shared";
import { WrappedLink } from "@components/navigation";
import { SportInteractionTypeEnum } from "@data-types/analytics-tracker/SportInteractionTypeEnum";
import TopTournamentMenuIcons from "@features/offer/shared/icon/TopTournamentMenuIcons";
import { updateUrlParams } from "@state";
import PrematchOfferMenuStore from "@state/stores/offer/prematch/PrematchOfferMenuStore";
import { analyticsTracker } from "@utils/analytics";
import { buildRoute } from "@utils/common/buildOfferRoute";
import classNames from "classnames";
import { observer } from "mobx-react";

export const TournamentItem = observer(function TournamentItem(props: {
	sport: PrematchOfferMenuStore["menu"];
	category: PrematchOfferMenuStore["menu"];
	tournament: PrematchOfferMenuStore["menu"];
	store: {
		toggleUpdateProcessing?: PrematchOfferMenuStore["toggleUpdateProcessing"];
		type: "PrematchOfferMenuStore" | "LiveOfferMenuStore";
	};
}) {
	const { culture, period } = useParams<{
		culture: string;
		period: string;
	}>();

	const url = buildRoute.tournamentCanonical({
		culture,
		period,
		sportAbrv: props.sport.node.abrv || "",
		tournamentAbrv: props.tournament.node.abrv || "",
		tournamentId: props.tournament.node.id,
	});

	const handleToggle = () => {
		if (props.store.toggleUpdateProcessing != null) {
			props.store.toggleUpdateProcessing();
		}
		if (props.store.type === "PrematchOfferMenuStore") {
			updateUrlParams({ page: 1 }, true);
		}
		props.tournament.onToggleCheck();
		if (props.tournament.checkState === 1) {
			analyticsTracker.trackSportInteraction(
				window.location.pathname.includes("live")
					? SportInteractionTypeEnum.LiveTournament
					: SportInteractionTypeEnum.PrematchTournament,
				`${props.tournament.parent?.parent?.node.abrv}-${props.tournament.parent?.node.abrv}-${props.tournament.node.abrv}`
			);
		}
		window.scrollTo(0, 0);
	};

	const isLive = props.store.type === "LiveOfferMenuStore";
	const linkClassName = classNames("nav--quaternary__link", {
		"is-active": props.tournament.checkState === 1,
	});

	const content = (
		<>
			<span className="input--check input--check--sml nav--quaternary__check">
				<Checkbox
					id={`sport-${props.sport.node.id}-category-${props.category.node.id}-tournament-${props.tournament.node.id}`}
					className={`at--${props.tournament.node.abrv} input--check__box input--check--sml__box nav--quaternary__box`}
					name={props.tournament.node.name}
					title={props.tournament.node.name}
					checked={props.tournament.checkState === 1}
					indeterminate={props.tournament.checkState === 2}
					onClick={(e) => {
						e.stopPropagation();
						handleToggle();
					}}
					onChange={() => {}}
				/>
				<label
					htmlFor={`sport-${props.sport.node.id}-category-${props.category.node.id}-tournament-${props.tournament.node.id}`}
					className="input--check__label input--check--sml__label nav--quaternary__label"
				>
					{props.tournament.node.isSpecialOffer ? (
						<TopTournamentMenuIcons
							tournamentAbrv={props.category.node.abrv || ""}
							sportAbrv={props.sport.node.sportAbrv || ""}
							className={
								"nav--tertiary__icon u-icon u-icon--base u-mar--right--micro"
							}
							imgClassName="nav--tertiary__icon__inner u-icon--base"
							isSpecialOffer
						/>
					) : (
						<OfferIcon
							type="tournament"
							sport={
								props.tournament.node.isTopTournament
									? props.tournament.node.sportAbrv || ""
									: props.sport.node.abrv || ""
							}
							category={
								props.tournament.node.isTopTournament
									? props.tournament.node.categoryAbrv || ""
									: props.category.node.abrv || ""
							}
							tournament={props.tournament.node.abrv || ""}
							wrapperClassName="nav--tertiary__icon u-icon u-icon--base u-mar--right--micro"
							className="nav--tertiary__icon__inner u-icon--base"
							treeIcon={true}
						/>
					)}
					<span>{props.tournament.node.name}</span>
				</label>
			</span>
			<span className="nav--quaternary__counter counter counter--base">
				{props.tournament.node.count}
			</span>
		</>
	);

	return (
		<li className="nav--quaternary__item">
			{isLive ? (
				<div className={linkClassName}>{content}</div>
			) : (
				<WrappedLink
					to={url}
					onClick={(e) => {
						e.preventDefault();
						e.stopPropagation();
						handleToggle();
					}}
					className={linkClassName}
				>
					{content}
				</WrappedLink>
			)}
		</li>
	);
});
